import { View } from 'react-native';

const Privacy = () => {
  return <View />;
};
export default Privacy;
